import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

export enum SalesforceMarketingCloudAuthType {
    OAuth_2_0 = 'OAuth_2.0',
    Enhanced_sts_OAuth_2_0 = 'Enhanced sts OAuth 2.0'
}

@Metamodel.model({
    name: 'SalesforceMarketingCloud',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.SalesforceMarketingCloud_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.SalesforceMarketingCloud_DisplayText)
    ]
})
export class SalesforceMarketingCloudLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientId
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientSecret,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public clientSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Subdomain
    })
    public subdomain?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseEncryptedEndpoints
    })
    public useEncryptedEndpoints?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseHostVerification
    })
    public useHostVerification?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_UsePeerVerification
    })
    public usePeerVerification?: boolean;

    public get authType(): SalesforceMarketingCloudAuthType {
        return this._authType;
    }

    public set authType(val: SalesforceMarketingCloudAuthType) {
        this._authType = val;
        if (this._authType === SalesforceMarketingCloudAuthType.OAuth_2_0) {
            this.host = 'www.exacttargetapis.com';
        }
    }

    public isOldResource: boolean = false;
    public isLegacyConnector: boolean = true;

    private _authType: SalesforceMarketingCloudAuthType;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
